import React, { Component } from 'react';
import { Modal, message, Spin, InputNumber, Input, Radio, Icon } from 'antd';
import $ from '../../../common/AjaxRequest.js';
import API_URL from '../../../common/url.js';
import './index.less';
import format from '../../shared/format.js';

const RadioGroup = Radio.Group;

const Config = {
    'apply': {
        title: '总价申请',
        url: API_URL.evaluate.requestClinicalQuotationAmount,
    },
    'examine': {
        title: '总价审批',
        url: API_URL.evaluate.approvalClinicalQuotationAmount,
    },
    'confirm': {
        title: '确认总价',
        url: API_URL.evaluate.confirmClinicalQuotationAdviseAmount,
    },
    'quotation': {
        title: '客户报价',
        url: API_URL.evaluate.setClinicalQuotationCoefficient,
    },
}

class TotalPriceModal extends Component {
    state = {
        params: {},
        config: {},
        visible: false,
        loading: false,
        type: '',
    }

    show = (record, type, data = {}) => {
        const { evaluateRecordId } = record;
        const { clinicalQuotationAmount, clinicalQuotationCoefficient } = data;
        this.setState({
            params: {
                evaluateRecordId,
                ...data,
                finallyMoney: (clinicalQuotationAmount && clinicalQuotationCoefficient) ? Number((clinicalQuotationAmount * clinicalQuotationCoefficient).toFixed(2)) : undefined,
            },
            visible: true,
            config: Config[type],
            type,
        },()=>{
            type == 'examine' && this.getClinicalQuotationRequest();
        });
    }

    //获取临床报价总价申请
    getClinicalQuotationRequest = () => {
        const { params, type } = this.state;
        const { evaluateRecordId } = params;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.getClinicalQuotationRequest,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { clinicalQuotationRequestId, clinicalEvaluateAmount, clinicalQuotationAmount, remarks } = data;
                this.setState({
                    params: { 
                        ...params, 
                        clinicalQuotationRequestId,
                        clinicalEvaluateAmount,
                        clinicalQuotationAmount,
                        remarks,
                    }
                })
            },
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({
            params: {},
            visible: false,
            loading: false,
        });
    }

    submit = () => {
        const { params, config, type } = this.state;
        const { 
            clinicalQuotationAmount,
            quotationApprovalStatus,
            approvalOpinion,
            clinicalQuotationCoefficient,
            finallyMoney,
        } = params;
        if (type == 'apply' && !clinicalQuotationAmount) {
            return message.warning('总价申请金额（不含税）/人民币不能为空！')
        } else if (type == 'examine' && !quotationApprovalStatus) {
            return message.warning('审核结论不能为空！')
        } else if (type == 'examine' && quotationApprovalStatus == 'QUOTATION_STATUS_REFUSED' && !approvalOpinion) {
            return message.warning('审批不通过原因不能为空！')
        } else if (type == 'quotation' && !clinicalQuotationCoefficient) {
            return message.warning('报价上浮比例不能为空！')
        } else if (type == 'quotation' && !finallyMoney) {
            return message.warning('最终报价金额（不含税）/人民币不能为空！')
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: config.url,
            data: {
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.props.loadData();
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        if (key == 'clinicalQuotationCoefficient') {
            if (value) {
                params.finallyMoney = Number((params.clinicalQuotationAmount * value).toFixed(2));
            } else{
                params.finallyMoney = undefined;
            }
        }
        this.setState({ params });
    }

    render() {
        const { visible, loading, params, config, type } = this.state;
        const { 
            clinicalEvaluateAmount,
            clinicalQuotationAmount, 
            remarks, 
            quotationApprovalStatus, 
            approvalOpinion, 
            clinicalQuotationAdviseAmount,
            finallyMoney,
            clinicalQuotationCoefficient,
        } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title={config.title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                maskClosable={false}
                confirmLoading={loading}
                width={550}
            >
                <Spin spinning={loading}>
                    <div className="apply_content" >
                        <div className="content_item" >
                            <div className="item_left" >总价金额（不含税）/人民币：</div>
                            <div className="item_right">{ format('money', clinicalEvaluateAmount)}</div>
                        </div>
                        <div className="content_item" >
                            <div className="item_left" >{asterisk}总价申请金额（不含税）/人民币：</div>
                            <div className="item_right" >
                                {
                                    (type == 'examine' || type == 'confirm' || type == 'quotation') ? 
                                        format('money', clinicalQuotationAmount)
                                        : <InputNumber
                                            placeholder='请输入'
                                            style={{ width: 200 }}
                                            min={0}
                                            precision={2}
                                            step={0.01}
                                            value={clinicalQuotationAmount}
                                            onChange={value => this.handleChange(value, 'clinicalQuotationAmount')}
                                        />
                                }
                            </div>
                        </div>
                        {
                            (type == 'quotation') && 
                            <div className="content_item" >
                                <div className="item_left">{asterisk}报价上浮比例：</div>
                                <div className="item_right">
                                    <InputNumber
                                        placeholder='请输入'
                                        style={{ width: 200 }}
                                        min={0}
                                        precision={2}
                                        step={0.01}
                                        value={clinicalQuotationCoefficient}
                                        onChange={value => this.handleChange(value, 'clinicalQuotationCoefficient')}
                                    />
                                </div>
                            </div>
                        }
                        {
                            (type == 'quotation') && 
                            <div className="content_item" >
                                <div className="item_left">{asterisk}最终报价金额（不含税）/人民币：</div>
                                <div className="item_right">
                                    <InputNumber
                                        placeholder='请输入'
                                        style={{ width: 200 }}
                                        disabled
                                        min={0}
                                        precision={2}
                                        step={0.01}
                                        value={finallyMoney}
                                        onChange={value => this.handleChange(value, 'finallyMoney')}
                                    />
                                </div>
                            </div>
                        }
                        <div className="content_item" >
                            <div className="item_left">备注说明：</div>
                            <div className="item_right">
                                {
                                    (type == 'examine' || type == 'confirm') ? remarks
                                        : <Input
                                            placeholder='请输入'
                                            style={{ width: 200 }}
                                            value={remarks}
                                            onChange={e => this.handleChange(e.target.value, 'remarks')}
                                        />
                                }
                            </div>
                        </div>
                            {(type == 'examine') && <div className='halvingLine'></div>}
                            {
                                (type == 'examine') && 
                                <div className="content_item" style={{ position: 'relative', left: -70 }}>
                                    <div className="item_left">{asterisk}审核结论：</div>
                                    <div className="item_right">
                                        <RadioGroup
                                            value={quotationApprovalStatus}
                                            onChange={e => this.handleChange(e.target.value, 'quotationApprovalStatus')}
                                        >
                                            <Radio style={{ marginLeft: '10px' }} value={'QUOTATION_STATUS_APPROVAL'}>审批通过</Radio>
                                            <Radio style={{ margin: '10px' }} value={'QUOTATION_STATUS_REFUSED'}>审批不通过</Radio>
                                            {/* <Radio style={{ margin: '10px' }} value={'QUOTATION_STATUS_REQUEST'}>待审批</Radio> */}
                                        </RadioGroup>
                                    </div>
                                </div>
                            }
                            {
                                (type == 'examine' && quotationApprovalStatus == 'QUOTATION_STATUS_REFUSED') &&
                                <div className="content_item">
                                    <div className="item_left">{asterisk}审批不通过原因：</div>
                                    <div className="item_right">
                                        <Input
                                            placeholder='请输入审批不通过原因'
                                            style={{ width: 200 }}
                                            value={approvalOpinion}
                                            onChange={e => this.handleChange(e.target.value, 'approvalOpinion')}
                                        />
                                    </div>
                                </div>
                            }
                            {
                                ((type == 'examine' && quotationApprovalStatus == 'QUOTATION_STATUS_REFUSED') || type == 'confirm') &&
                                <div className="content_item">
                                    <div className="item_left">建议报价金额（不含税）/人民币：</div>
                                    <div className="item_right">
                                        {(type == 'confirm') ? 
                                            format('money', clinicalQuotationAdviseAmount)
                                        : <InputNumber
                                                placeholder='请输入'
                                                style={{ width: 200 }}
                                                min={0}
                                                precision={2}
                                                step={0.01}
                                                value={clinicalQuotationAdviseAmount}
                                                onChange={value => this.handleChange(value, 'clinicalQuotationAdviseAmount')}
                                            />}
                                    </div>
                                </div>
                            }
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default TotalPriceModal;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/TotalPriceModal.js